const DatabaseConfig = () => import('@/views/main/helper/databaseConfig/DatabaseConfig.vue')
export default {
  path: '/main/helper/databaseConfig',
  name: 'DatabaseConfig',
  component: DatabaseConfig,
  children: []
}
